import Button from './button/button';
import 'edge/platform/atomic_design/molecules/module';

export default angular.module('edge.platform.atomic_design', [
    'edge.platform.atomic_design.molecules'
])
    .directive('gwButton', Button);